import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M14.781 13.5c2.313 0 4.219 1.906 4.219 4.219v.781a1.5 1.5 0 0 1-1.5 1.5h-11A1.48 1.48 0 0 1 5 18.5v-.781C5 15.406 6.875 13.5 9.188 13.5c.906 0 1.312.5 2.812.5 1.469 0 1.875-.5 2.781-.5m2.719 5v-.781A2.72 2.72 0 0 0 14.781 15c-.469 0-1.187.5-2.781.5-1.625 0-2.344-.5-2.812-.5-1.5 0-2.688 1.219-2.688 2.719v.781zM12 13c-2.5 0-4.5-2-4.5-4.5C7.5 6.031 9.5 4 12 4c2.469 0 4.5 2.031 4.5 4.5 0 2.5-2.031 4.5-4.5 4.5m0-7.5c-1.656 0-3 1.375-3 3a3 3 0 0 0 3 3c1.625 0 3-1.344 3-3 0-1.625-1.375-3-3-3"
    />
  </svg>
);
export default SvgAccount;
